<template>
  <div class="expander">
    <div @click="() => {isExpanded = !isExpanded}" class="expanderTarget" :class="{opened: isExpanded}">
        <div class="initialContent"><h3 v-html="expander_initial_content"></h3></div>
    </div>
    <SlideUpDown
      :active="isExpanded"
      :initialHeight="0"
      class="myCollapse"
      :aria-expanded="isExpanded ? 'true' : 'false'"
    >
      <div v-html="expander_content"></div>
    </SlideUpDown>
  </div>
</template>

<script>
import SlideUpDown from '@/components/SlideUpDown'

export default {
  name: "WordpressExpander",
  props: ["acf_fc_layout", "expander_content", "expander_initial_content"],
  components:{
      SlideUpDown,
  },
  data(){
      return{
          isExpanded: false
      }
  }
};
</script>

<style lang="scss" scoped>

.expander{
	border-bottom: 1px lightgrey solid;
	max-width: 850px;
	margin: 0 auto;
	margin-bottom: 10px;
	line-height: 20pt;
	padding-top: 16px;
	padding-bottom: 3px;

	&::v-deep{
		table{
			border-collapse: collapse;
			thead tr, tr:nth-child(2n){
				background-color: #f6f6f6;
			}
			th, td {
				border: 1px solid #eaeaea;
				max-width: 110px;
				height: 70px;
			}
			th {
				text-align: center;
				color: #fff;
				&.gold {
					background-color: $CTgold;
				}
				&.silver {
					background-color: $CTSilver;
				}
				&.platinum {
					background-color: $CTPlatinum;
				}
			}
			tbody tr:nth-child(n+2) td:nth-child(n+2){
				text-align: center;
			}
		}
	}
}
.expanderTarget{
	// background:grey;
	position:relative;
	padding-left:35px;
	cursor: pointer;
	user-select: none;
	&:before, &:after {
		content: '';
		width:25px;
		height:5px;
		position:absolute;
		background:$CTred;
		left:0px;
		top: 50%;
		transform: translate(0, -50%);
		transition: all ease 0.2s;
	}
	&:after {
		transform: translate(0,-50%) rotate(90deg) ;
	}
	&.opened:after{
		transform: translate(0,-50%) rotate(0deg);
	}
	.initialContent{
		display:inline;
		font-weight: 600;
		h3 { 
			font-size: 1em !important;
		}
	}
	h3, h4{
		font-weight: bold;
		color: #000;
		font-size: 1.2em;
	}
}

.myCollapse{
	margin: 10px 0;
}

</style>
